export default "__VITE_ASSET__92fb37d1__"